// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CKdH","label":"styles_label__3n0ec"};